import { useRef, useState } from "react";
import styles from "./Navigation.module.css";
import React from "react";
import { SubSectionProps } from "./types";

export function NavigationSubSection({ header, expanded, children, icon }: SubSectionProps) {
  const [open, setOpen] = useState(expanded);
  const mouseDownRef = useRef(false);

  // if there was a single NavLink child that returned false, don't render anything
  if (children === false) {
    return null;
  }

  // if there is a single truthy NavLink child, wrap it in an array to render below
  if (!Array.isArray(children)) {
    children = [children];
  }

  // filter out any falsey children (that is, NavLinks that returned false)
  const definedChildren = children.filter((child) => !!child);

  // if there are no active children, render nothing
  if (definedChildren.length === 0) {
    return null;
  }

  // if there is only one child, render it
  if (definedChildren.length === 1) {
    return React.cloneElement(definedChildren[0], {
      icon: icon ? <i className={`${styles.navigationLinkIcon} narmi-icon-${icon}`} /> : null,
      children: header,
    });
  }

  return (
    <div className={styles.navigationSubSection}>
      <div
        className={styles.navigationSectionHeader}
        role="button"
        tabIndex={0}
        onMouseDown={() => {
          mouseDownRef.current = true;
          setOpen(!open);
        }}
        onFocus={() => {
          if (mouseDownRef.current) {
            mouseDownRef.current = false;
            return;
          }
          setOpen(true);
        }}
      >
        <div className={styles.navigationSectionHeaderText}>{header}</div>
        <i className={`narmi-icon-${open ? "chevron-up" : "chevron-down"}`} />
      </div>
      <div
        // to prevent re-initializing the children on open/close, the open state controls the display value
        // rather than adding/removing the children from the DOM.
        className={styles.navigationSubSectionLinks}
        style={{ display: open ? undefined : "none" }}
      >
        {children}
      </div>
    </div>
  );
}
